export enum responseTypes {
  BLOB = 'blob',
}
